const dummyData = {
    "calls": [
      {
        "id": "uuid1",
        "assistantId": 1,
        "type": 2,
        "startedAt": "2025-04-23T10:00:00Z",
        "endedAt": "2025-04-23T10:30:00Z",
        "recordingUrl": "http://example.com/recording1.mp3",
        "cost": 10.0,
        "summary": 5,
        "status": 1,
        "createdAt": "2025-04-23T10:00:00Z",
        "updatedAt": "2025-04-23T10:15:00Z"
      }
    ],
    "assistant": [
      {
        "id": "uuid2",
        "assistantID": "assistant1",
        "model": "Model-X",
        "firstMessage": "Hello, how can I assist you?",
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ],
    // done
    "jarvis": [
      {
        "id": "uuid3",
        "api_key": "api12345",
        "assistantId": "assistant1",
        "organizationId": "org1"
      },
      {
        "id": "uuid3",
        "api_key": "api12345",
        "assistantId": "assistant1",
        "organizationId": "org1"
      },
      {
        "id": "uuid3",
        "api_key": "api12345",
        "assistantId": "assistant1",
        "organizationId": "org1"
      }
    ],
    // jarvis end
    "role": [
      {
        "id": "uuid4",
        "name": "Admin",
        "guard_name": "admin_guard",
        "status": true,
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ],
    "user": 
      {
        "id": "uuid5",
        "firstName": "Akash",
        "lastName": "Malhotra",
        "displayName": "Akash Malhotra",
        "email": "admin@admin.com",
        "password": "hashedPassword123",
        "roleId": "uuid4",
        "organizationId": "org1",
        "status": 1,
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ,
    "organization": [
      {
        "id": "org1",
        "name": "Tech Corp",
        "status": true,
        "entity_type": "company",
        "noOfEmployees": 100,
        "addressLine1": "123 Tech Street",
        "addressLine2": "Suite 200",
        "pincode": 123456,
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ],
    "subscriptions": [
      {
        "id": "uuid6",
        "organizationId": "org1",
        "packageId": "pkg1",
        "packageData": 100,
        "addonId": "addon1",
        "startDate": "2025-04-01",
        "endDate": "2025-04-30",
        "totalAmount": 200.0,
        "paymentType": 1,
        "txnId": "txn123",
        "transactionDetail": "Payment for subscription",
        "paymentStatus": 1,
        "status": true,
        "billingCycle": "monthly",
        "callback": "http://example.com/callback",
        "cancelDate": "2025-04-30",
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ],
    "package": [
      {
        "id": "pkg1",
        "name": "Standard Plan",
        "monthlyPrice": 100.0,
        "yearlyPrice": 1000.0,
        "includedMinutes": 500,
        "extraMinuteRate": 0.2,
        "assistantLimit": 5,
        "extraAssistantRate": 50.0,
        "isCustom": false,
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ],
    "package_addons": [
      {
        "id": "addon1",
        "name": "Call Recording",
        "price": 10.0,
        "billingCycle": "monthly",
        "description": "Add-on for call recording",
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ],
    "phone_number": [
      {
        "id": 1,
        "provider": "Verizon",
        "phoneNumber": "1234567890",
        "organizationId": "org1",
        "createdAt": "2025-04-01T08:00:00Z",
        "updatedAt": "2025-04-01T08:00:00Z"
      }
    ]
  };
  

export default dummyData;